'use strict';

function getOrdinalSuffix(num) {
  if (num >= 11 && num <= 13) {
    return 'th';
  } else {
    switch(num % 10) {
      case 1:  return 'st';
      case 2:  return 'nd';
      case 3:  return 'rd';
      default: return 'th';
    }
  }
}

module.exports = getOrdinalSuffix;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/getOrdinalSuffix.js
// module id = 244
// module chunks = 0